import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex min-h-[70vh] w-full flex-col items-center justify-center overflow-hidden px-4 py-20 text-center">
      <span className="font-heading pointer-events-none absolute select-none text-[9rem] font-black leading-none text-background-800 md:text-[14rem]">
        404
      </span>
      <div className="relative z-10">
        <span className="flex h-16 w-16 mx-auto items-center justify-center rounded-full bg-background-800 text-primary-400">
          <i className="ri-film-line text-3xl"></i>
        </span>
        <h1 className="mt-6 text-2xl font-bold text-foreground-50 md:text-3xl">找不到这个页面</h1>
        <p className="mx-auto mt-3 max-w-md text-sm text-foreground-400">
          你要找的影视内容或页面可能已被移动或删除。
        </p>
        <p className="mt-2 font-mono text-xs text-foreground-600">{location.pathname}</p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-950 transition-colors hover:bg-primary-400"
          >
            <i className="ri-home-5-line"></i>
            返回首页
          </Link>
          <Link
            to="/category/movie"
            className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-700 px-6 py-3 text-sm font-medium text-foreground-100 transition-colors hover:border-primary-500 hover:text-primary-400"
          >
            <i className="ri-film-line"></i>
            浏览电影
          </Link>
        </div>
      </div>
    </div>
  );
}